import { useMutation, useQuery } from "./helper";
import { assignJob, assignOperator, getAllWorkSessions, getWorkingSessionGeometry, getWorkSession } from "../../../api/work-session";
import { TWorkSession } from "../../types";
import { TResponseItemWrapper, TResponseListWrapper } from "../../types/common";

export const useWorkSessionsList = (params, options) => useQuery<TResponseListWrapper<TWorkSession>>({
    queryKey: ['work-sessions', params],
    queryFn: () => getAllWorkSessions(params),
    ...options
});

export const useWorkSession = (id, options) => useQuery<TResponseItemWrapper<TWorkSession>>({
    queryKey: ['work-session', id],
    queryFn: () => getWorkSession(id),
    ...options
});

type WorkSessionAssignJobVariables = {
    workingSessionId: number | string;
    jobId: number | string;
};

type WorkSessionAssignOperatorVariables = {
    workingSessionId: number | string;
    operatorId: number | string;
};

export const useWorkSessionAssignJob = () => useMutation<
    unknown,
    Error,
    WorkSessionAssignJobVariables
>({
    mutationFn: (payload) => assignJob(payload),
});

export const useWorkSessionAssignOperator = () => useMutation<
    unknown,
    Error,
    WorkSessionAssignOperatorVariables
>({
    mutationFn: (payload) => assignOperator(payload),
});

export const useWorkSessionGeometry = (workingSessionId, options) => useQuery<TResponseItemWrapper<any>>({
    queryKey: ['work-session-geometry', workingSessionId],
    queryFn: () => getWorkingSessionGeometry(workingSessionId),
    ...options
});